import React, { useState } from "react";
import PlayVideo from "../assets/playVideo";
import "./Exhibitions.scss";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/plugins/counter.css";
import "yet-another-react-lightbox/styles.css";

const Exhibitions = () => {
  const exhibitionInfo = [
    {
      caption: "2024-2025 Solo Exhibition, Municipal Art Gallery, Athens",
      img: ["/images/exhibitions/solo-exhibition-2024-2025-athens/1.jpg",
        "/images/exhibitions/solo-exhibition-2024-2025-athens/2.jpg",
        "/images/exhibitions/solo-exhibition-2024-2025-athens/3.jpg",
        "/images/exhibitions/solo-exhibition-2024-2025-athens/4.jpg"
      ],
    },
    {
      caption: "2024 Solo Exhibition, Municipal Art Gallery, Piraeus",
      img: ["/images/exhibitions/art-gallery-piraeus-2024.jpg",
        "/images/exhibitions/installation_dromokaiteio.jpg"],
    },
    {
      caption: "2022 Group Exhibition, Arts Center Noass, Riga, Latvia",
      img: ["/images/exhibitions/riga-2022.jpg"],
    },
    {
      caption: "2020 Solo Exhibition, Can Gallery, Athens, Greece",
      img: ["/images/exhibitions/can-gallery-athens-2020.jpg"],
    },
    {
      caption: "2018 Solo Exhibition, Can Gallery, Athens",
      img: ["/images/exhibitions/solo-exhibition-can-gallery-athens-greece-2018/1-intro-the-dark.jpeg",
        "/images/exhibitions/solo-exhibition-can-gallery-athens-greece-2018/2-intro-the-dark.jpeg"
      ],
    },
  ];

  const [openLightbox, setOpenLightbox] = useState(
    Array(exhibitionInfo.length).fill(false)
    // [false,false,false]
  );

  const renderInstallations = () => {

    return (
      <>
        {exhibitionInfo.map((item, index) => (
          <div className="installation-item" key={index}>
            <button
              className="border-0 bg-transparent p-0 mb-0" onClick={() => {
                const updatedOpenLightbox = [...openLightbox];
                updatedOpenLightbox[index] = true;
                setOpenLightbox(updatedOpenLightbox);
              }}
            >
              <img className="w-100" src={item.img[0]} alt="" />
            </button>
            <span className="pt-1 lh-1 d-block font-size-12 pt-2">{item.caption}</span>

            <Lightbox className={item.img.length > 1 ? '' : 'lightbox-single-img'}
              open={openLightbox[index]}
              close={() => {
                const updatedOpenLightbox = [...openLightbox];
                updatedOpenLightbox[index] = false;
                setOpenLightbox(updatedOpenLightbox);
              }}
              slides={item.img.map((src) => ({ src }))}
              carousel={{ finite: true }}
            />

          </div>
        ))}
      </>
    );
  };

  return (
    <div className="page-body">
      <div className="exhibitions-wrapper  container container-medium position-relative">
        <h1 className="mb-4">Exhibitions</h1>
        <div className="row gx-5">
          <div className="col-md-8 exhibition-list-wrapper">
            {/* <ul className="list-unstyled exhibition-list mb-4">
              <li className="list-header font-semibold font-size-14 ">
                CURRENT
              </li>
            
            </ul> */}

            <ul className="list-unstyled exhibition-list mb-4">
              <li className="list-header font-semibold font-size-14">SOLO</li>
              <li>
                <a href="https://vimeo.com/1065070360" target="_blank" rel="noreferrer"><PlayVideo />2024 November Solo Exhibition, Municipal Art Gallery, Athens</a>
              </li>
              <li>
                <a href="https://vimeo.com/1010677068" target="_blank" rel="noreferrer"><PlayVideo />2024 June Solo Exhibition, Municipal Art Gallery, Piraeus</a></li>
              <li>
                2020 Solo Exhibition, CAN Christina Androulidaki Gallery, Athens,
                Greece
              </li>
              <li>2018 Solo Exhibition CAN Gallery, Athens, Greece</li>

              <li>2017 Solo EXhibition, Paros, Cyclades, Greece</li>
              <li>2016 Solo Exhibition in Morfes Gallery, Rethymno, Crete</li>
            </ul>

            <ul className="list-unstyled exhibition-list mb-4">
              <li className="list-header font-semibold font-size-14">GROUP</li>
              <li>2025 Group Exhibition,Underland,curated by Christoforos Marinos,Evia,Greece</li>
              <li>2023 Group Exhibition, Stigma,Dromokaiteio Psychiatric Hospital of Athens, Greece</li>
              <li>2022 Group Exhibition, Expressions of Light, Santorini, Greece</li>
              <li>2022 Group Exhibition, Shanghai Museum, China</li>
              <li>2022 Group Exhibition, Gallery 265, Paros, Greece</li>
              <li>2022 Group Exhibition, Arts Center Noass, Riga, Latvia</li>
              <li>2022 Group Exhibition, Gallery 7, Athens, Greece</li>
              <li>2021 Group Exhibition, Mirko Mayer Gallery. Cologne, Germany</li>
              <li>
                2020 Group Exhibition, CAN Christina Androulidaki Gallery, Athens,
                Greece
              </li>
              <li>2020 Group Exhibition, National Art Centre, Tokyo, Japan</li>
              <li>2020 Group Exhibition, Mirko Mayer Gallery, Mykonos, Greece</li>
              <li>2019 Group Exhibition, Salon d;Autumn Paris, France</li>
              <li>2019 Group Exhibition, DL Gallery, Pireas, Greece</li>
              <li>
                2018 June group exhibition Zoumpoulakis galleries Athens, Greece
              </li>
              <li>2017 Group Exhibition, dl Gallery, Piraeus, Greece</li>
              <li>2016 Group Exhibition in Box Gallery, Athens</li>
              <li>2015 Group Exhibition in Hellenic American Union, Athens</li>
              <li>
                2014 Participation Group Exhibition at Box Gallery, Athens
              </li>
            </ul>
          </div>
          <div className="col-md-4 installations-wrapper">
            <span className="d-block list-header ">INSTALLATIONS</span>
            {renderInstallations()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Exhibitions;